module.exports = __webpack_public_path__ + "img/footer_img1.40594451.png";